import script from "./SeedTimelineRelatorios.vue?vue&type=script&setup=true&lang=js"
export * from "./SeedTimelineRelatorios.vue?vue&type=script&setup=true&lang=js"

import "./SeedTimelineRelatorios.vue?vue&type=style&index=0&id=2ad0ed3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad0ed3a"]])

export default __exports__